import {
  getActionNameWithStatus,
  getResetAction,
} from "../../constants/actions-methods";
import { requestStatus } from "../../constants/request";
import { serverApis } from "../../constants/server-apis";

export const productionUnPickInboxListReducer = (state = [], action) => {
  const actionName = serverApis.productionUnPickInboxList.actionName;
  switch (action.type) {
    case getActionNameWithStatus(actionName, requestStatus.SUCCESS):
      return [...state, ...action.json.sales_orders];

    case getResetAction(actionName):
      return [];
    default:
      return state;
  }
};
